module.exports = __webpack_public_path__ + "media/images/area/sub_hero_map_kochi-42b3914a02dfe3f2bb57e71c6bb6c2cb.png";